/* 🤖 this file was generated by svg-to-ts */
export const matIconSend: {
  name: 'send';
  data: string;
} = {
  name: 'send',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m4.01 6.03 7.51 3.22-7.52-1 .01-2.22m7.5 8.72L4 17.97v-2.22l7.51-1M2.01 3 2 10l15 2-15 2 .01 7L23 12 2.01 3z"/></svg>`
};
